import type {
    AdministrativeUnitCodebookResponse,
    UserVerificationConfirmRequest,
    UserVerificationInfoResponse,
    UserVerificationInitData,
    UserVerificationInitRequest,
    UserVerificationInitResponse,
} from '@leanpay/models'
import { HttpClient } from '@leanpay/http-client'
import { toAdministrativeUnit, toUserVerificationInitData } from '@leanpay/models'

import { errorHandler } from '../errorHandler'
import { verificationInterceptor } from '../interceptors'

class UserVerificationService {
    _httpClient = new HttpClient({
        config: { baseURL: undefined },
        interceptorConfig: {
            onRequestFulfilled: verificationInterceptor,
            onRejected: errorHandler,
        },
    })

    private _verificationInitUrl = 'api/user/verification/init'
    private _newVerificationConfirmUrl = 'api/user/verification/confirm'
    private _newVerificationStatusUrl = 'api/user/verification/'
    private _administrativeUnitsUrl = 'api/address-codebook/administrative-units'

    async verificationInit(
        payload: UserVerificationInitRequest,
    ): Promise<UserVerificationInitData> {
        const { data } = await this._httpClient.post<UserVerificationInitResponse>(
            this._verificationInitUrl,
            payload,
        )
        return toUserVerificationInitData(data)
    }

    async verificationConfirm(payload: UserVerificationConfirmRequest) {
        const { data } = await this._httpClient.post<UserVerificationInfoResponse>(
            this._newVerificationConfirmUrl,
            payload,
        )

        return data
    }

    async getVerificationStatus(correlationId?: string) {
        const url = this._newVerificationStatusUrl + correlationId!

        const { data } = await this._httpClient.get<UserVerificationInfoResponse>(url)

        return data
    }

    async getAdministrativeUnits(countryCodebookId: string) {
        const url = `${this._administrativeUnitsUrl}?countryCodebookId=${countryCodebookId}`
        const { data } = await this._httpClient.get<AdministrativeUnitCodebookResponse[]>(url)
        const res = data.map((unit) => toAdministrativeUnit(unit))

        return res
    }
}

export const userVerificationService = new UserVerificationService()
